var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1726_2455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.426904 9.88029C0.426436 11.5607 0.868936 13.2014 1.71034 14.6477L0.346436 19.5889L5.44269 18.263C6.85225 19.0244 8.43155 19.4233 10.0364 19.4235H10.0407C15.3387 19.4235 19.6514 15.1457 19.6537 9.88781C19.6547 7.33998 18.6557 4.94416 16.8405 3.14168C15.0257 1.33936 12.612 0.346256 10.0403 0.345093C4.74159 0.345093 0.42917 4.62261 0.426982 9.88029",
    fill: "url(#paint0_linear_1726_2455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0835938 9.87721C0.0830469 11.6181 0.541406 13.3175 1.41281 14.8155L0 19.9339L5.27898 18.5605C6.73352 19.3474 8.37117 19.7622 10.0376 19.7629H10.0419C15.53 19.7629 19.9977 15.3312 20 9.88512C20.0009 7.24574 18.9659 4.7638 17.0859 2.89674C15.2057 1.02992 12.7057 0.00108527 10.0419 0C4.55281 0 0.0857813 4.43101 0.0835938 9.87721ZM3.22742 14.5575L3.03031 14.2471C2.20172 12.9398 1.76437 11.4291 1.765 9.87783C1.76672 5.35109 5.47953 1.66822 10.045 1.66822C12.2559 1.66915 14.3337 2.52434 15.8966 4.07597C17.4593 5.62775 18.3192 7.69054 18.3187 9.8845C18.3166 14.4112 14.6037 18.0946 10.0419 18.0946H10.0386C8.5532 18.0938 7.09641 17.698 5.82594 16.95L5.52359 16.7721L2.39094 17.5871L3.22742 14.5575Z",
    fill: "url(#paint1_linear_1726_2455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55303 5.74789C7.36662 5.3368 7.17045 5.32851 6.99318 5.3213C6.84803 5.31509 6.68209 5.31556 6.51631 5.31556C6.35037 5.31556 6.08076 5.3775 5.85287 5.6244C5.62475 5.87153 4.98193 6.46874 4.98193 7.68339C4.98193 8.89804 5.87357 10.072 5.99787 10.2369C6.12232 10.4015 7.7192 12.9739 10.2483 13.9635C12.3501 14.7859 12.7779 14.6223 13.234 14.5811C13.6903 14.54 14.7062 13.984 14.9135 13.4075C15.1209 12.8311 15.1209 12.337 15.0587 12.2337C14.9965 12.1308 14.8306 12.069 14.5818 11.9456C14.3329 11.8222 13.1096 11.2249 12.8815 11.1425C12.6534 11.0601 12.4876 11.019 12.3216 11.2663C12.1557 11.5131 11.6792 12.069 11.534 12.2337C11.3889 12.3987 11.2437 12.4193 10.9949 12.2958C10.7459 12.1719 9.94459 11.9115 8.99389 11.0705C8.2542 10.4161 7.75482 9.60796 7.60967 9.36075C7.46451 9.11393 7.59412 8.98013 7.71889 8.85711C7.83068 8.74649 7.96779 8.56882 8.09232 8.42471C8.21639 8.28052 8.25779 8.17765 8.34076 8.013C8.42381 7.8482 8.38225 7.70401 8.32014 7.58052C8.25779 7.45703 7.77428 6.23603 7.55303 5.74789Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1726_2455",
    x1: 965.71,
    y1: 1924.73,
    x2: 965.71,
    y2: 0.345093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1726_2455",
    x1: 1000,
    y1: 1993.39,
    x2: 1000,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1726_2455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhats);
export default __webpack_public_path__ + "static/media/whats.6e7cf55aed658b0cc9f4671f99c0bdb6.svg";
export { ForwardRef as ReactComponent };